var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1842_21678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.73 61.0802C153.92 57.1102 151.58 53.6202 148.22 51.3702C144.85 49.1202 140.73 48.2902 136.76 49.0602L122.65 51.8002C126.23 49.8702 128.89 46.6002 130.07 42.7102C131.24 38.8202 130.83 34.6202 128.91 31.0402C127.37 28.1602 124.95 25.8502 122 24.4502C119.05 23.0502 115.72 22.6502 112.52 23.2902L18.2504 42.5702C16.2504 42.8402 14.3304 43.5102 12.5904 44.5302C10.8504 45.5502 9.33043 46.9002 8.11043 48.5002C6.89043 50.1002 6.00043 51.9302 5.49043 53.8802C4.98043 55.8302 4.86043 57.8602 5.13043 59.8502C5.40043 61.8502 6.07043 63.7702 7.09043 65.5102C8.11043 67.2502 9.46043 68.7702 11.0604 69.9902C12.6604 71.2102 14.4904 72.1002 16.4404 72.6102C18.3904 73.1202 20.4204 73.2402 22.4104 72.9702C23.0504 72.9002 23.6804 72.7602 24.3004 72.5702L29.5604 71.4802C26.2204 73.7702 23.9204 77.3002 23.1804 81.2902C22.4404 85.2802 23.3004 89.3902 25.5904 92.7402C26.7704 94.4902 28.3104 95.9802 30.1104 97.0902C31.9104 98.2002 33.9204 98.9202 36.0204 99.1902L29.5604 100.38C27.5504 100.62 25.6004 101.26 23.8404 102.25C22.0804 103.24 20.5304 104.59 19.2804 106.19C18.0404 107.79 17.1304 109.63 16.6004 111.58C16.0704 113.54 15.9404 115.58 16.2104 117.59C16.4804 119.6 17.1504 121.53 18.1704 123.28C19.2004 125.03 20.5604 126.56 22.1804 127.77C23.8004 128.99 25.6504 129.87 27.6104 130.37C29.5804 130.87 31.6204 130.97 33.6204 130.67C34.2204 130.57 34.8104 130.47 35.3104 130.37L135.34 111.2C138.98 110.43 142.21 108.36 144.43 105.38C146.65 102.4 147.72 98.7202 147.43 95.0102C147.14 91.3002 145.51 87.8302 142.85 85.2402C140.19 82.6502 136.67 81.1102 132.96 80.9102L142.7 79.0202C146.65 78.2002 150.13 75.8602 152.38 72.5102C154.63 69.1502 155.47 65.0502 154.72 61.0802H154.73Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4006 107.38C104.431 107.38 120.661 91.1499 120.661 71.1199C120.661 51.0899 104.431 34.8599 84.4006 34.8599C64.3706 34.8599 48.1406 51.0999 48.1406 71.1199C48.1406 91.1399 64.3806 107.38 84.4006 107.38Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 51H112C114.761 51 117 53.2386 117 56V104C117 106.761 114.761 109 112 109H48C45.2386 109 43 106.761 43 104V56L43.0068 55.7432C43.1405 53.1011 45.3247 51 48 51Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 51H112C114.761 51 117 53.2386 117 56V65H43V56C43 53.2386 45.2386 51 48 51Z",
    fill: "#F2F2F2",
    stroke: "#222222",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 57,
    width: 26,
    height: 3,
    rx: 1.5,
    fill: "#F2F2F2",
    stroke: "#222222",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.91 80C111.567 80 108.301 80.9914 105.517 82.8472C102.733 84.7029 100.573 87.3467 99.2889 90.4353C98.0052 93.524 97.6747 96.9304 98.3229 100.21C98.9712 103.489 100.585 106.501 102.95 108.866C105.314 111.23 108.326 112.844 111.605 113.492C114.885 114.14 118.291 113.81 121.38 112.526C124.468 111.242 127.112 109.082 128.968 106.298C130.824 103.514 131.815 100.248 131.815 96.905C131.815 94.6806 131.383 92.4817 130.531 90.4353C129.68 88.3889 128.434 86.5205 126.871 84.9444C125.295 83.3683 123.439 82.1227 121.38 81.2838C119.321 80.4449 117.122 80 114.91 80Z",
    fill: "#D3242A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.91 80C111.567 80 108.301 80.9914 105.517 82.8472C102.733 84.7029 100.573 87.3467 99.2889 90.4353C98.0052 93.524 97.6747 96.9304 98.3229 100.21C98.9712 103.489 100.585 106.501 102.95 108.866C105.314 111.23 108.326 112.844 111.605 113.492C114.885 114.14 118.291 113.81 121.38 112.526C124.468 111.242 127.112 109.082 128.968 106.298C130.824 103.514 131.815 100.248 131.815 96.905C131.815 94.6806 131.383 92.4817 130.531 90.4353C129.68 88.3889 128.434 86.5205 126.871 84.9444C125.295 83.3683 123.439 82.1227 121.38 81.2838C119.321 80.4449 117.122 80 114.91 80V80Z",
    stroke: "#222222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.395 91.6937L111.733 97.0322L106.395 102.371L109.572 105.548L114.911 100.21L120.249 105.548L123.427 102.371L118.088 97.0322L123.427 91.6937L120.249 88.5161L114.911 93.8545L109.572 88.5161L106.395 91.6937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.395 91.6937L111.733 97.0322L106.395 102.371L109.572 105.548L114.911 100.21L120.249 105.548L123.427 102.371L118.088 97.0322L123.427 91.6937L120.249 88.5161L114.911 93.8545L109.572 88.5161L106.395 91.6937V91.6937Z",
    stroke: "#222222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 58,
    r: 3,
    fill: "#D0D0D0",
    stroke: "#222222",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 58,
    r: 3,
    fill: "#D0D0D0",
    stroke: "#222222",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 58,
    r: 3,
    fill: "#D0D0D0",
    stroke: "#222222",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1842_21678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 114.68,
    fill: "white",
    transform: "translate(5 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.6cebc46afe1cc232a8e6461eb7b0360c.svg";
export { ForwardRef as ReactComponent };